import React from 'react';
import {Toolbar, Link, useMediaQuery, Divider} from '@material-ui/core';
import logo from '../../Assets/ascension-rx-logo.svg';
import {makeStyles} from "@material-ui/core/styles";
import routes from "../../constants/routes";
import { useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    dialogWrapper: {
        padding: theme.spacing(0),
        position: 'absolute',
        top: theme.spacing(3)
    },
    dialogTitle: {
        marginLeft: 20,
        padding: theme.spacing(1),
    },
    subTitle: {
        color: "#223354",
        opacity: 0.7,
        fontSize: 16,
        fontWeight: 300,
        lineHeight: 1,
    },
    dialogContent: {
        margin: 0,
        padding: theme.spacing(1),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}));
const Header = () => {
    const classes = useStyles();
    const theme = useTheme();
    const fullscreen = useMediaQuery(theme.breakpoints.up('lg'));
    return (
        <div >
            {/*todo header nav bars*/}
            <Toolbar align="center">
                <div>
                    {fullscreen ?
                        <div style={{ height: "10px" , top: "35px"}}>
                            <Link href={"https://ascensionrx.com/"}>
                                <img src={logo} alt="logo" style={{width: "180px"}} className={classes.headerLogo}/>
                            </Link>
                        </div>
                        :
                        <div>
                            <Link href={"https://ascensionrx.com/"}>
                                <img src={logo} alt="logo" style={{width: "180px", height: "60px"}} className={classes.headerLogo}/>
                            </Link>
                        </div>
                    }
                </div>
            </Toolbar>
            <Divider style={{borderBottom: "1px solid #ebebeb", marginTop: "25px"}}/>
        </div>
    )
}

export default Header;